<template>
  <v-panel>
    <v-form ref="form" v-model="valid">
      <div class="divider">
        <span>
          <b>Dados das Despesas - Manutenção</b>
        </span>
      </div>
      <v-flex md11>
        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Pastagens</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <b>Manutenção (fertilizantes, herbicidas, roçadas etc.)</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoFertilizante"
                  v-model="formulario.manutencaoFertilizante"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <b>Arrendamento de pastagem de terceiros</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoArrendamento"
                  v-model="formulario.manutencaoArrendamento"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <!--Manutenção De Instalações e Benfeitorias-->
        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Manutenção de instalações e benfeitorias</b>
          </span>
        </div>

        <v-divider></v-divider>
        <v-layout align-center justify row wrap>
          <v-flex xs6 sm5 md5>
            <div class="divider2 text-xs-center">
              <span>
                <b>Porcentagem do custo original que corresponde a essas despesas</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="porcentagemCustoOriginalInstalacoes"
              v-model="formulario.porcentagemCustoOriginalInstalacoes"
              type="number"
              background-color="white"
              label="%"
              box
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout align-center justify-center row wrap>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo01">{{formularioInstalacoes.TituloInstalacoes01}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao01"
                  v-model="formulario.manutencao01"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo02">{{formularioInstalacoes.TituloInstalacoes02}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao02"
                  v-model="formulario.manutencao02"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo03">{{formularioInstalacoes.TituloInstalacoes03}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao03"
                  v-model="formulario.manutencao03"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo04">{{formularioInstalacoes.TituloInstalacoes04}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao04"
                  v-model="formulario.manutencao04"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo05">{{formularioInstalacoes.TituloInstalacoes05}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao05"
                  v-model="formulario.manutencao05"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo06">{{formularioInstalacoes.TituloInstalacoes06}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao06"
                  v-model="formulario.manutencao06"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo07">{{formularioInstalacoes.TituloInstalacoes07}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao07"
                  v-model="formulario.manutencao07"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo08">{{formularioInstalacoes.TituloInstalacoes08}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao08"
                  v-model="formulario.manutencao08"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo09">{{formularioInstalacoes.TituloInstalacoes09}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao09"
                  v-model="formulario.manutencao09"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo10">{{formularioInstalacoes.TituloInstalacoes10}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao10"
                  v-model="formulario.manutencao10"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo11">{{formularioInstalacoes.TituloInstalacoes11}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao11"
                  v-model="formulario.manutencao11"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo12">{{formularioInstalacoes.TituloInstalacoes12}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao12"
                  v-model="formulario.manutencao12"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo13">{{formularioInstalacoes.TituloInstalacoes13}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao13"
                  v-model="formulario.manutencao13"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo14">{{formularioInstalacoes.TituloInstalacoes14}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao14"
                  v-model="formulario.manutencao14"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo15">{{formularioInstalacoes.TituloInstalacoes15}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao15"
                  v-model="formulario.manutencao15"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo16">{{formularioInstalacoes.TituloInstalacoes16}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao16"
                  v-model="formulario.manutencao16"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo17">{{formularioInstalacoes.TituloInstalacoes17}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao17"
                  v-model="formulario.manutencao17"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo18">{{formularioInstalacoes.TituloInstalacoes18}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao18"
                  v-model="formulario.manutencao18"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo19">{{formularioInstalacoes.TituloInstalacoes19}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao19"
                  v-model="formulario.manutencao19"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo20">{{formularioInstalacoes.TituloInstalacoes20}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao20"
                  v-model="formulario.manutencao20"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Manutenção de máquinas e equipamentos</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify row wrap>
          <v-flex xs6 sm5 md5>
            <div class="divider2 text-xs-center">
              <span>
                <b>Porcentagem do preço de compra, correspondente a essas despesas</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="porcentagemPrecoCompra"
              v-model="formulario.porcentagemPrecoCompra"
              type="number"
              background-color="white"
              label="%"
              box
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout align-center justify-center row wrap>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo21">{{formularioMaquinas.TituloMaquinas01}}</div>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao21"
                  v-model="formulario.manutencao21"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo22">{{formularioMaquinas.TituloMaquinas02}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao22"
                  v-model="formulario.manutencao22"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo23">{{formularioMaquinas.TituloMaquinas03}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao23"
                  v-model="formulario.manutencao23"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo24">{{formularioMaquinas.TituloMaquinas04}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao24"
                  v-model="formulario.manutencao24"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo25">{{formularioMaquinas.TituloMaquinas05}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao25"
                  v-model="formulario.manutencao25"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo26">{{formularioMaquinas.TituloMaquinas06}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao26"
                  v-model="formulario.manutencao26"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo27">{{formularioMaquinas.TituloMaquinas07}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao27"
                  v-model="formulario.manutencao27"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo28">{{formularioMaquinas.TituloMaquinas08}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao28"
                  v-model="formulario.manutencao28"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo29">{{formularioMaquinas.TituloMaquinas09}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao29"
                  v-model="formulario.manutencao29"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo30">{{formularioMaquinas.TituloMaquinas10}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao30"
                  v-model="formulario.manutencao30"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo31">{{formularioMaquinas.TituloMaquinas11}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao31"
                  v-model="formulario.manutencao31"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo32">{{formularioMaquinas.TituloMaquinas12}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao32"
                  v-model="formulario.manutencao32"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo33">{{formularioMaquinas.TituloMaquinas13}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao33"
                  v-model="formulario.manutencao33"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo34">{{formularioMaquinas.TituloMaquinas14}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao34"
                  v-model="formulario.manutencao34"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo35">{{formularioMaquinas.TituloMaquinas15}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao35"
                  v-model="formulario.manutencao35"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo36">{{formularioMaquinas.TituloMaquinas16}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao36"
                  v-model="formulario.manutencao36"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo37">{{formularioMaquinas.TituloMaquinas17}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao37"
                  v-model="formulario.manutencao37"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo38">{{formularioMaquinas.TituloMaquinas18}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao38"
                  v-model="formulario.manutencao38"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo39">{{formularioMaquinas.TituloMaquinas19}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao39"
                  v-model="formulario.manutencao39"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo40">{{formularioMaquinas.TituloMaquinas20}}</div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao40"
                  v-model="formulario.manutencao40"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo41"></div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao41"
                  v-model="formulario.manutencao41"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo42"></div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao42"
                  v-model="formulario.manutencao42"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo43"></div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao43"
                  v-model="formulario.manutencao43"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo44"></div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao44"
                  v-model="formulario.manutencao44"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo45"></div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao45"
                  v-model="formulario.manutencao45"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo46"></div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao46"
                  v-model="formulario.manutencao46"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo47"></div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao47"
                  v-model="formulario.manutencao47"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo48"></div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao48"
                  v-model="formulario.manutencao48"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo49"></div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao49"
                  v-model="formulario.manutencao49"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo50"></div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao50"
                  v-model="formulario.manutencao50"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo51"></div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao51"
                  v-model="formulario.manutencao51"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo52"></div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao52"
                  v-model="formulario.manutencao52"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo53"></div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao53"
                  v-model="formulario.manutencao53"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo54"></div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao54"
                  v-model="formulario.manutencao54"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <div id="titulo55"></div>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencao55"
                  v-model="formulario.manutencao55"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
                {{form}}
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-form>
  </v-panel>
</template>
<script>
/* eslint-disable */
import { EventBus } from "../../event-bus.js";
import DadosDespesasManutencao from "../../class/DadosDespesasManutencao.js";
import DadosRecursosInstalacoes from "../../class/DadosRecursosInstalacoes.js";
import DadosRecursosMaquinas from "../../class/DadosRecursosMaquinas.js";

EventBus.$on("titulo-instalacoes01", titulo1 => {
  document.getElementById("titulo01").innerHTML = titulo1;
});
EventBus.$on("titulo-instalacoes02", titulo2 => {
  document.getElementById("titulo02").innerHTML = titulo2;
});
EventBus.$on("titulo-instalacoes03", titulo3 => {
  document.getElementById("titulo03").innerHTML = titulo3;
});
EventBus.$on("titulo-instalacoes04", titulo4 => {
  document.getElementById("titulo04").innerHTML = titulo4;
});
EventBus.$on("titulo-instalacoes05", titulo5 => {
  document.getElementById("titulo05").innerHTML = titulo5;
});
EventBus.$on("titulo-instalacoes06", titulo6 => {
  document.getElementById("titulo06").innerHTML = titulo6;
});
EventBus.$on("titulo-instalacoes07", titulo7 => {
  document.getElementById("titulo07").innerHTML = titulo7;
});
EventBus.$on("titulo-instalacoes08", titulo8 => {
  document.getElementById("titulo08").innerHTML = titulo8;
});
EventBus.$on("titulo-instalacoes09", titulo9 => {
  document.getElementById("titulo09").innerHTML = titulo9;
});
EventBus.$on("titulo-instalacoes10", titulo10 => {
  document.getElementById("titulo10").innerHTML = titulo10;
});
EventBus.$on("titulo-instalacoes11", titulo11 => {
  document.getElementById("titulo11").innerHTML = titulo11;
});
EventBus.$on("titulo-instalacoes12", titulo12 => {
  document.getElementById("titulo12").innerHTML = titulo12;
});
EventBus.$on("titulo-instalacoes13", titulo13 => {
  document.getElementById("titulo13").innerHTML = titulo13;
});
EventBus.$on("titulo-instalacoes14", titulo14 => {
  document.getElementById("titulo14").innerHTML = titulo14;
});
EventBus.$on("titulo-instalacoes15", titulo15 => {
  document.getElementById("titulo15").innerHTML = titulo15;
});
EventBus.$on("titulo-instalacoes16", titulo16 => {
  document.getElementById("titulo16").innerHTML = titulo16;
});
EventBus.$on("titulo-instalacoes17", titulo17 => {
  document.getElementById("titulo17").innerHTML = titulo17;
});
EventBus.$on("titulo-instalacoes18", titulo18 => {
  document.getElementById("titulo18").innerHTML = titulo18;
});
EventBus.$on("titulo-instalacoes19", titulo19 => {
  document.getElementById("titulo19").innerHTML = titulo19;
});
EventBus.$on("titulo-instalacoes20", titulo20 => {
  document.getElementById("titulo20").innerHTML = titulo20;
});
EventBus.$on("titulo-maquinas01", titulo21 => {
  document.getElementById("titulo21").innerHTML = titulo21;
});
EventBus.$on("titulo-maquinas02", titulo22 => {
  document.getElementById("titulo22").innerHTML = titulo22;
});
EventBus.$on("titulo-maquinas03", titulo23 => {
  document.getElementById("titulo23").innerHTML = titulo23;
});
EventBus.$on("titulo-maquinas04", titulo24 => {
  document.getElementById("titulo24").innerHTML = titulo24;
});
EventBus.$on("titulo-maquinas05", titulo25 => {
  document.getElementById("titulo25").innerHTML = titulo25;
});
EventBus.$on("titulo-maquinas06", titulo26 => {
  document.getElementById("titulo26").innerHTML = titulo26;
});
EventBus.$on("titulo-maquinas06", titulo26 => {
  document.getElementById("titulo26").innerHTML = titulo26;
});
EventBus.$on("titulo-maquinas07", titulo27 => {
  document.getElementById("titulo27").innerHTML = titulo27;
});
EventBus.$on("titulo-maquinas08", titulo28 => {
  document.getElementById("titulo28").innerHTML = titulo28;
});
EventBus.$on("titulo-maquinas09", titulo29 => {
  document.getElementById("titulo29").innerHTML = titulo29;
});
EventBus.$on("titulo-maquinas10", titulo30 => {
  document.getElementById("titulo30").innerHTML = titulo30;
});
EventBus.$on("titulo-maquinas11", titulo31 => {
  document.getElementById("titulo31").innerHTML = titulo31;
});
EventBus.$on("titulo-maquinas12", titulo32 => {
  document.getElementById("titulo32").innerHTML = titulo32;
});
EventBus.$on("titulo-maquinas13", titulo33 => {
  document.getElementById("titulo33").innerHTML = titulo33;
});
EventBus.$on("titulo-maquinas14", titulo34 => {
  document.getElementById("titulo34").innerHTML = titulo34;
});
EventBus.$on("titulo-maquinas15", titulo35 => {
  document.getElementById("titulo35").innerHTML = titulo35;
});
EventBus.$on("titulo-maquinas16", titulo36 => {
  document.getElementById("titulo36").innerHTML = titulo36;
});
EventBus.$on("titulo-maquinas17", titulo37 => {
  document.getElementById("titulo37").innerHTML = titulo37;
});
EventBus.$on("titulo-maquinas18", titulo38 => {
  document.getElementById("titulo38").innerHTML = titulo38;
});
EventBus.$on("titulo-maquinas19", titulo39 => {
  document.getElementById("titulo39").innerHTML = titulo39;
});
EventBus.$on("titulo-maquinas20", titulo40 => {
  document.getElementById("titulo40").innerHTML = titulo40;
});
EventBus.$on("titulo-maquinas21", titulo41 => {
  document.getElementById("titulo41").innerHTML = titulo41;
});
EventBus.$on("titulo-maquinas22", titulo42 => {
  document.getElementById("titulo42").innerHTML = titulo42;
});
EventBus.$on("titulo-maquinas23", titulo43 => {
  document.getElementById("titulo43").innerHTML = titulo43;
});
EventBus.$on("titulo-maquinas24", titulo44 => {
  document.getElementById("titulo44").innerHTML = titulo44;
});
EventBus.$on("titulo-maquinas25", titulo45 => {
  document.getElementById("titulo45").innerHTML = titulo45;
});
EventBus.$on("titulo-maquinas26", titulo46 => {
  document.getElementById("titulo46").innerHTML = titulo46;
});
EventBus.$on("titulo-maquinas27", titulo47 => {
  document.getElementById("titulo47").innerHTML = titulo47;
});
EventBus.$on("titulo-maquinas28", titulo48 => {
  document.getElementById("titulo48").innerHTML = titulo48;
});
EventBus.$on("titulo-maquinas29", titulo49 => {
  document.getElementById("titulo49").innerHTML = titulo49;
});
EventBus.$on("titulo-maquinas30", titulo50 => {
  document.getElementById("titulo50").innerHTML = titulo50;
});
EventBus.$on("titulo-maquinas31", titulo51 => {
  document.getElementById("titulo51").innerHTML = titulo51;
});
EventBus.$on("titulo-maquinas32", titulo52 => {
  document.getElementById("titulo52").innerHTML = titulo52;
});
EventBus.$on("titulo-maquinas33", titulo53 => {
  document.getElementById("titulo53").innerHTML = titulo53;
});
EventBus.$on("titulo-maquinas34", titulo54 => {
  document.getElementById("titulo54").innerHTML = titulo54;
});
EventBus.$on("titulo-maquinas35", titulo55 => {
  document.getElementById("titulo55").innerHTML = titulo55;
});

export default {
  inject: ["$validator"],
  data: () => ({
    formulario: new DadosDespesasManutencao(),
    formularioInstalacoes: new DadosRecursosInstalacoes(),
    formularioMaquinas: new DadosRecursosMaquinas(),
    panel: [],
    select: null,
    items: ["Sim", "Não"],
    lazy: true,
    valid: false,
    simulation: ""
  }),
  mounted() {
    var self = this;
    this.$db.simulation.get(this.$route.params.code, function(s) {
      self.simulation = s;
    });
  },
  computed: {
    form: function() {
      this.$db.simulation.get({ code: this.simulation.code }, dado => {
        this.formulario = new DadosDespesasManutencao(dado.dadosManutencao);
        this.formularioInstalacoes = new DadosRecursosInstalacoes(dado.dadosRecursosInstalacoes);
        this.formularioMaquinas = new DadosRecursosMaquinas(dado.dadosRecursosMaquinas);
      });
    }
  },
  methods: {
    clear() {
      this.formulario = {
        formulario: Object.assign(this.$data, this.$options.data.apply())
      };
      this.$validator.reset();
    }
  }
};
</script>
<style scoped>
h2 {
  color: #00695c;
}

.botaoNone {
  border: solid black 1px;
  position: fixed;
  margin-bottom: 0;
  z-index: 997;
  bottom: 45px;
  right: 24px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

@media screen and (max-width: 991px) {
  h2 {
    color: #00695c;
  }
  .container {
    position: relative;
    text-align: center;

    background-color: #00695c;
    min-height: 100vh;
    max-width: none;

    color: azure;
  }

  .panel {
    margin-top: 1%;
    padding-left: 2%;
    padding-right: 2%;
    padding-bottom: 1%;
    background-color: white;
    box-shadow: 0 4px 15px black;
  }
  .form {
    margin-top: 2%;

    min-width: 100%;
  }
  .text-field {
    background-color: blue;
    font-size: 2px;
  }
  .select {
    background-color: blue;
    font-size: 2px;
  }
  .flex {
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
  }
  .button {
    float: right;
  }
  .divider {
    text-align: center;
    font-size: 130%;
    color: #00695c;
  }
  .divider2 text-xs-center {
    margin-top: 5%;
    margin-left: 5%;
    font-size: 110%;
  }
}

@media screen and (min-width: 992px) {
  h2 {
    color: #00695c;
  }
  .container {
    margin-top: 2%;
    text-align: center;

    background-color: #00695c;
    min-height: 100vh;
    max-width: none;

    color: azure;
  }
  .panel {
    width: 60%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
    padding-bottom: 1%;
    background-color: white;
    box-shadow: 0 4px 10px black;
  }
  .panelGrafico {
    width: 70%;
  }
  .flex {
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
  }

  .button {
    float: right;
  }

  .divider {
    text-align: center;
    font-size: 180%;
    color: #00695c;
  }
  .divider2 text-xs-center {
    font-size: 150%;
    margin-top: 5%;
    margin-left: 5%;
  }
  .layout {
    padding-left: 5%;
    padding-right: 5%;
  }
}
</style>